export default "__VITE_ASSET__BJuHzXUc__"